import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import logoTitan from "../../assets/logoTitan.png";
import { ALERT, BASE_URL } from "../../config/constants";

export default function Home({ setIsAuth }) {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  async function formulario(data) {
    setIsSubmitting(true);

    try {
      const res = await axios.post(`${BASE_URL}/auth/login`, data);

      localStorage.setItem("token", res.data.token);
      setIsAuth(true);
      navigate("/admin");
    } catch (error) {
      console.error("Error login:", error?.response?.data || error.message);

      ALERT.fire({
        icon: "error",
        title: "¡...Error de autenticación...!",
        text: error?.response?.data?.msg || "No fue posible iniciar sesión",
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div
      className="min-vh-100 d-flex flex-column"
      style={{
        background: "linear-gradient(180deg, #050b18 0%, #081224 100%)",
      }}
    >
      <div className="container flex-grow-1 py-3 py-lg-4 d-flex align-items-center">
        <div className="row w-100 g-3 g-lg-4 align-items-center">
          <div className="col-12 col-lg-6 d-flex">
            <div className="w-100 d-flex flex-column justify-content-center text-white pe-lg-3">
              <div
                className="d-inline-flex align-items-center gap-2 rounded-pill px-3 py-2 mb-2"
                style={{
                  width: "fit-content",
                  backgroundColor: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.10)",
                  fontSize: "0.8rem",
                  color: "rgba(255,255,255,0.75)",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#1450ff",
                    display: "inline-block",
                  }}
                />
                Portal unificado para Titán App y Extranet
              </div>

              <h1
                className="fw-semibold lh-sm mb-3"
                style={{
                  fontSize: "clamp(1.8rem, 4vw, 3.2rem)",
                  letterSpacing: "-0.02em",
                }}
              >
                La transformación digital es ahora, cada día más
                <span style={{ color: "#6aa1ff" }}> TITÁN</span>.
              </h1>

              <p
                className="mb-3"
                style={{
                  maxWidth: "560px",
                  color: "rgba(255,255,255,0.75)",
                  fontSize: "0.96rem",
                  lineHeight: "1.55",
                }}
              >
                Centraliza el acceso a las herramientas y plataformas de TITÁN
                en una sola experiencia moderna, clara y accesible para todos
                los usuarios.
              </p>

              <div className="mt-2">
                <div
                  className="rounded-4 p-3"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    maxWidth: "460px",
                  }}
                >
                  <div
                    className="fw-semibold mb-1"
                    style={{ color: "#ffffff", fontSize: "0.95rem" }}
                  >
                    Acceso simple, rápido y seguro
                  </div>
                  <div
                    style={{
                      color: "rgba(255,255,255,0.65)",
                      fontSize: "0.88rem",
                      lineHeight: "1.5",
                    }}
                  >
                    Ingresa con tus credenciales para continuar al portal y
                    administrar tus procesos desde una sola plataforma.
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <a
                  href="https://mesadeayuda.titancemento.com/portal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                  style={{
                    backgroundColor: "rgba(20,80,255,0.12)",
                    color: "#cfe0ff",
                    border: "1px solid rgba(106,161,255,0.35)",
                    borderRadius: "0.8rem",
                    padding: "0.7rem 1rem",
                    fontSize: "0.9rem",
                    fontWeight: 500,
                    textDecoration: "none",
                  }}
                >
                  Para creación de tickets o solicitudes al área de sistemas,
                  click aquí
                </a>
              </div>
            </div>
          </div>

          {/* Lado derecho - Login */}
          <div className="col-12 col-lg-6 d-flex">
            <div className="w-100 d-flex align-items-center justify-content-center">
              <div
                className="w-100 rounded-4 shadow-lg"
                style={{
                  maxWidth: "460px",
                  backgroundColor: "rgba(6, 20, 43, 0.95)",
                  border: "1px solid rgba(255,255,255,0.10)",
                  backdropFilter: "blur(6px)",
                }}
              >
                <div
                  className="px-4 pt-4 pb-1 text-center"
                  style={{
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                  }}
                >
                  <img
                    src={logoTitan}
                    alt="Logo TITÁN"
                    style={{
                      width: "150px",
                      height: "80px",
                      objectFit: "contain",
                    }}
                  />

                  <h2
                    className="mb-1 fw-semibold text-white"
                    style={{ fontSize: "1.45rem" }}
                  >
                    Iniciar sesión
                  </h2>
                </div>

                <div className="px-4 py-4">
                  <form onSubmit={handleSubmit(formulario)}>
                    <div className="mb-3">
                      <label
                        htmlFor="email"
                        className="form-label mb-2"
                        style={{
                          color: "rgba(255,255,255,0.78)",
                          fontSize: "0.9rem",
                        }}
                      >
                        Correo electrónico
                      </label>
                      <input
                        type="email"
                        id="email"
                        placeholder="example@email.com"
                        disabled={isSubmitting}
                        className="form-control"
                        style={{
                          backgroundColor: "rgba(255,255,255,0.05)",
                          border: errors.email
                            ? "1px solid rgba(220,53,69,0.7)"
                            : "1px solid rgba(255,255,255,0.15)",
                          color: "#fff",
                          padding: "0.72rem 0.9rem",
                          borderRadius: "0.8rem",
                          boxShadow: "none",
                          fontSize: "0.95rem",
                        }}
                        {...register("email", { required: true })}
                      />
                      {errors.email?.type === "required" && (
                        <div
                          className="mt-2"
                          style={{ color: "#ffb3b3", fontSize: "0.8rem" }}
                        >
                          Correo es obligatorio
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="password"
                        className="form-label mb-2"
                        style={{
                          color: "rgba(255,255,255,0.78)",
                          fontSize: "0.9rem",
                        }}
                      >
                        Contraseña
                      </label>
                      <input
                        type="password"
                        id="password"
                        placeholder="••••••••"
                        disabled={isSubmitting}
                        className="form-control"
                        style={{
                          backgroundColor: "rgba(255,255,255,0.05)",
                          border: errors.password
                            ? "1px solid rgba(220,53,69,0.7)"
                            : "1px solid rgba(255,255,255,0.15)",
                          color: "#fff",
                          padding: "0.72rem 0.9rem",
                          borderRadius: "0.8rem",
                          boxShadow: "none",
                          fontSize: "0.95rem",
                        }}
                        {...register("password", { required: true })}
                      />
                      {errors.password?.type === "required" && (
                        <div
                          className="mt-2"
                          style={{ color: "#ffb3b3", fontSize: "0.8rem" }}
                        >
                          Contraseña es obligatoria
                        </div>
                      )}
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <Link
                        to="/register"
                        style={{
                          color: "#9ec1ff",
                          textDecoration: "none",
                          fontSize: "0.86rem",
                        }}
                      >
                        Registrarse
                      </Link>

                      <Link
                        to="/forgot-pws"
                        style={{
                          color: "#9ec1ff",
                          textDecoration: "none",
                          fontSize: "0.86rem",
                        }}
                      >
                        ¿Olvidé mi contraseña?
                      </Link>
                    </div>

                    <button
                      type="submit"
                      className="btn w-100 fw-semibold"
                      disabled={isSubmitting}
                      style={{
                        backgroundColor: "#1450ff",
                        color: "#fff",
                        borderRadius: "0.8rem",
                        padding: "0.75rem 1rem",
                        border: "none",
                        boxShadow: "0 10px 24px rgba(20,80,255,0.20)",
                        fontSize: "0.95rem",
                      }}
                    >
                      {isSubmitting ? "Iniciando sesión..." : "Iniciar sesión"}
                    </button>

                    <div
                      className="text-center mt-3"
                      style={{
                        color: "rgba(255,255,255,0.48)",
                        fontSize: "0.78rem",
                        lineHeight: "1.5",
                      }}
                    >
                      En caso de no poder iniciar sesión, haz click{" "}
                      <a
                        href="https://mesadeayuda.titancemento.com/portal"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#cfe0ff",
                          textDecoration: "underline",
                        }}
                      >
                        aquí
                      </a>{" "}
                      y registra tu caso.
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
